import AdminContainer from '../../Utility/AdminContainer';
import PaginatedCard from '../Dashboard/PaginatedCard';
import useComplianceDashboard from '../../../Hooks/useComplianceDashboard';
import { DlpTrackCountPerUserType, DlpTrackCountPerGroupType } from '../../../Types';
import { PaginationListType } from '../../../Types/PaginationParams';
import DateRangePicker from '../../Utility/DateRangePicker';

const ComplianceDashboard = () => {
    const {
        DashboardActions,
        timeRange,
        selectedLanguage,
        i18n,
        dlpTrackTooltip,
        getDlpTrackCountPerUser,
        getDlpTrackCountPerGroup,
    } = useComplianceDashboard();

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="md:flex md:justify-between">
                    <DateRangePicker
                        timeRange={timeRange}
                        selectedLanguage={selectedLanguage}
                        i18n={i18n}
                        onTimeRangeChange={(range: { from: Date; to: Date }) => {
                            DashboardActions.setTimeRangeWithTime({ from: range.from, to: range.to });
                        }}
                    />
                </div>

                <div>
                    <div className="grid grid-cols-12 gap-4 mt-4">
                        <div className="col-span-12 lg:col-span-6">
                            <PaginatedCard<DlpTrackCountPerUserType>
                                listType={PaginationListType.DlpTrackCountPerUser}
                                title={i18n.translate({ id: 'title.dlpTrackCountPerUser', sourceName: 'Dashboard' })}
                                itemsFunction={getDlpTrackCountPerUser}
                                renderItem={(user: DlpTrackCountPerUserType, index: number) => (
                                    <div key={index} className="flex justify-between gap-3">
                                        <p className="truncate text-ellipsis">
                                            {user.deleted ? (
                                                <i>{i18n.translate({ id: 'deleted', sourceName: 'Dashboard' })}</i>
                                            ) : (
                                                user.givenName + ' ' + user.familyName
                                            )}
                                            <br />
                                            <span className="text-gray-500 truncate text-ellipsis">
                                                {user.deleted ? '-' : user.email}
                                            </span>
                                        </p>
                                        <p
                                            className="whitespace-nowrap tooltip"
                                            data-tooltip-content={dlpTrackTooltip(user)}
                                        >
                                            {user.sensitiveCount + '/' + (user.anonymizedCount + user.sensitiveCount)}
                                        </p>
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-6">
                            <PaginatedCard<DlpTrackCountPerGroupType>
                                listType={PaginationListType.DlpTrackCountPerGroup}
                                title={i18n.translate({ id: 'title.dlpTrackCountPerGroup', sourceName: 'Dashboard' })}
                                itemsFunction={getDlpTrackCountPerGroup}
                                renderItem={(group: DlpTrackCountPerGroupType, index: number) => (
                                    <div key={index} className="flex justify-between gap-3">
                                        <p className="truncate text-ellipsis">
                                            {group.title}
                                            <br />
                                            <span className="text-gray-500 truncate text-ellipsis">
                                                {group.userCount +
                                                    ' ' +
                                                    i18n.translate({ id: 'users', sourceName: 'Dashboard' })}
                                            </span>
                                        </p>
                                        <p
                                            className="whitespace-nowrap tooltip"
                                            data-tooltip-content={dlpTrackTooltip(group)}
                                        >
                                            {group.sensitiveCount +
                                                '/' +
                                                (group.anonymizedCount + group.sensitiveCount)}
                                        </p>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </AdminContainer>
        </div>
    );
};

export default ComplianceDashboard;
